export const ACADEMY_EXERCISE_CONTEXT_KEY = 'academy:practical-exercise-context';
export const ACADEMY_PIP_SESSION_KEY = 'academy:pip:hostState';